import { render, staticRenderFns } from "./FieldWorkplace2Write.vue?vue&type=template&id=0806ef17&scoped=true&"
import script from "./FieldWorkplace2Write.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplace2Write.vue?vue&type=script&lang=js&"
import style0 from "./FieldWorkplace2Write.vue?vue&type=style&index=0&id=0806ef17&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806ef17",
  null
  
)

export default component.exports